import { Link } from "react-router-dom";

import { styled } from "@mui/material/styles";
import { darken, Grid, Typography } from "@mui/material";
import { DataGrid as MuiDataGrid } from "@mui/x-data-grid";
import { COLORS } from "../../_globalStore/redux/reducers/Theme/themeConstants";

export const DataGrid = styled(MuiDataGrid)(({ theme }) => ({
  // background: "white",
  border: "none",
  // marginTop:"10px",
  "& .MuiDataGrid-columnHeaders": {
    // marginBottom:"15px",
    // backgroundColor: theme.palette.background.paper,
    // borderRadius: "12px ",
    // border: "none",
    // fontWeight:400
    // fontSize: theme.typography.subtitle1,
    // color: theme.palette.text.disabled
  },
  "& .MuiDataGrid-row": {
    "& .MuiDataGrid-cell:not(:last-of-type)": {
      // border: "none",
      borderRight: `1px solid ${darken(COLORS.black_gradients.greyLight, 0.025)}`,
    },
  },
}));

export const Actions = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
  alignItems: "center",
  gap: "3px",
  margin: "0 5px",
}));

export const AddButtonLink = styled(Link)({
  color: "white",
  padding: "6px 10px",
  border: "1px solid white",
  borderRadius: "3px",
});

export const EditButtonLink = styled(Link)(({ theme }) => ({
  minWidth: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.primary.main,
}));

export const RenderButtonBlock = styled(Grid)({
  display: "flex",
  gap: "10px",
});

export const ReadonlyIconContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  justifyContent: "center",
});

export const ColumnsHeaderTitle = styled(Typography)({
  display: "-webkit-box",
  WebkitLineClamp: "3",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
});
